export default __webpack_public_path__ + "static/media/ic-plusWhite.1850557f.svg";